import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { ClockRotateLeft } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

interface Props {
  changesShown: boolean
}

export const UserItemMenuContent: React.FC<Props> = ({ changesShown }) => {
  const changesTitle = changesShown ? 'Hide changes' : 'Show changes'

  return (
    <>
      <DropdownMenu.Button id="changes" title={changesTitle} />
      <DropdownMenu.Divider />
      <DropdownMenu.Button
        id="restore"
        title="Restore"
        icon={ClockRotateLeft}
      />
    </>
  )
}
